import React, { ReactNode } from "react"
import { Price, Heading, Paragraph, ProductImagePlaceholder } from ".."
import { Product } from "../types.d"

interface ProductPreviewProps {
  product: Product
  image?: ReactNode
}

export const ProductPreview = ({ product, image }: ProductPreviewProps) => {
  const { title, description, productType, price } = product
  return (
    <article className="block w-full max-w-xs cursor-pointer rounded-lg shadow-sm duration-200 hover:-translate-y-1 hover:shadow-lg">
      <div className="aspect-square overflow-hidden rounded-t-lg bg-white object-cover">
        {image || <ProductImagePlaceholder productType={productType} />}
      </div>
      <div className="rounded-b-lg bg-white p-2 md:p-4">
        {/* We set a dedicated height to ensure that the preview always has the same height */}
        {/* (even if there is no description/title) */}
        <div className="mb-6 flex h-[40px] flex-col gap-1 md:h-[82px]">
          <Heading level={4}>{title}</Heading>
          <Paragraph level={3} lineClamp={2}>
            {description}
          </Paragraph>
        </div>
        <div className="flex justify-end">
          <Price value={price?.inNear} size="small" />
        </div>
      </div>
    </article>
  )
}
